import { palette } from '@versports/theme'

/**
 * Mini serie temporal inline (SVG, sin Chart.js): para los tiles en vivo, que
 * se actualizan cada segundo y sólo necesitan mostrar la forma reciente de la
 * señal. Montar un Chart.js por tile sería mucho más caro y no aporta ejes
 * que a este tamaño no se leen igual.
 */
export function Sparkline({
  values,
  color = palette.primary,
  height = 28,
}: {
  values: number[]
  color?: string
  height?: number
}) {
  if (values.length < 2) return null

  const width = 100
  const min = Math.min(...values)
  const max = Math.max(...values)
  // Rango plano (señal constante): dibujar la línea al medio en vez de dividir
  // por cero.
  const span = max - min || 1
  const points = values
    .map((value, i) => {
      const x = (i / (values.length - 1)) * width
      const y = height - ((value - min) / span) * (height - 2) - 1
      return `${x.toFixed(2)},${y.toFixed(2)}`
    })
    .join(' ')

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      className="mt-xs h-[28px] w-full"
      aria-hidden="true"
    >
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  )
}
